import * as React from "react";

import { Flex } from "@common/components/Flex";

import { MultiselectList } from "./components/multiselect-list";
import { DropdownList } from "./components/dropdown-list";
import { InvitesFilterProps } from "./invites-filter.types";
import { useInviteFilterController } from "./invites-filter.controller";

import "./invites-filter.styles.scss";

export const InvitesFilter: React.FC<InvitesFilterProps> = (props) => {
  const { multiselectFilterConfig, withinFilterConfig } = useInviteFilterController(props);

  return (
    <div className="InvitesFilter">
      <Flex width="100%">
        {multiselectFilterConfig.map((config, i) => (
          <MultiselectList
            key={i}
            id={config.id}
            label={config.label}
            options={config.options}
            onChange={config.onChange}
            value={config.value}
            className="InvitesFilter__multiselect-list"
            classes={{
              multiselectListBox: "InvitesFilter__multiselect-list__box",
            }}
          />
        ))}

        <div className="InvitesFilter__dropdown-list">
          {withinFilterConfig.map((config, i) => (
            <DropdownList
              key={i}
              id={config.id}
              label={config.label}
              options={config.options}
              onChange={config.onChange as ((day: string) => void)}
              value={config.value}
            />
          ))}
        </div>
      </Flex>
    </div>
  );
};
